<template>
  <div class="box">
    <img :src="coverImg"
      class="img">
    <div class="enter-btn-box">
      <img @click="onEnter"
        class="btn-enter"
        src="../../assets/interest/btn_enter.png">
    </div>
  </div>
</template>

<script>
import Toast from 'vux/src/components/toast'
import { actions, injectMixins } from '@/services'
import { setupShence } from '@/helpers'
import coreUtil from '@/utils/core'
import sensors from '@/utils/sensors'

export default {
  mixins: [injectMixins],
  data () {
    return {
      coverImg: '' // 封面url
    }
  },
  async created () {
    // 神策初始化
    await setupShence()
    // 获取入口海报
    this.getSurveyBaseInfo()
    // 获取问答详情
    this.getUserLastedAssess()
  },
  methods: {
    // 获取入口海报
    async getSurveyBaseInfo () {
      if (!this.cpCode) {
        this.$toast.error('题目编号获取失败')
        return
      }
      this.pageLoading = true
      const ret = await actions.aassessment(this.code)
      this.pageLoading = false
      if (ret.code === 200) {
        const data = ret.data || {}
        const row = data.cpLists[0]
        this.coverImg = row.image
        document.title = row.name
        coreUtil.setLocal('wechat-title', row.name)
      } else {
        this.$toast.error('海报获取失败')
      }
    },
    // 获取问答详情
    async getUserLastedAssess () {
      const ret = await actions.getUserLastedAssess(this.code)
      if (ret.code === 200 && ret.data) {
        const query = this.$route.query
        this.$router.replace({ path: '/interest/result', query })
      }
    },
    // 入口
    onEnter () {
      const query = this.$route.query
      this.$router.push({ path: '/interest/examine', query })
      // 神策埋点
      const sensorConfig = {
        app_title: document.title,
        app_button: '开始测评'
      }
      sensors.appWebClick(sensorConfig)
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  min-height: 100vh;
  padding-bottom: 70px;
  position: relative;
  .img {
    width: 100%;
  }
  .enter-btn-box {
    background-color: #ffffff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 70px;
    padding: 20px 0;
    position: fixed;
    bottom: 0;
    text-align: center;
    width: 100%;
    .btn-enter {
      width: 80%;
      &:active {
        opacity: 0.5;
      }
    }
  }
}
</style>
